/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  var ll = $(document).find('[data-section-type="product"] .ProductForm__Option--labelled').length;
  var lli = $('[data-section-type="product"] input.SizeSwatch__Radio:checked').length;
  if(ll == lli){
    $(document).find('[data-section-type="product"] .ProductForm__AddToCart').removeClass('cmtNone');
    $(document).find('[data-section-type="product"] .shopify-payment-button').removeClass('cmtNone');
    $('.selOption').hide();
    $('.noSelect').hide();
    $('.atc').show();
  }
  else{
    $(document).find('[data-section-type="product"] .ProductForm__AddToCart').addClass('cmtNone');
    $(document).find('[data-section-type="product"] .shopify-payment-button').addClass('cmtNone');
    $('.selOption').show();
    $('.noSelect').show();
    $('.atc').hide();
  }
});

$(document).ready(function(){
  var ll = $(document).find('[data-section-type="product"] .ProductForm__Option--labelled').length;
  var lli = $('[data-section-type="product"] input.SizeSwatch__Radio:checked').length; 
  if(ll == lli){
    $(document).find('[data-section-type="product"] .ProductForm__AddToCart').removeClass('cmtNone');
    $(document).find('[data-section-type="product"] .shopify-payment-button').removeClass('cmtNone');
   // $('.selOption').hide();
    $('.noSelect').hide();
    $('.atc').show();
  }
  else{
    $(document).find('[data-section-type="product"] .ProductForm__AddToCart').addClass('cmtNone');
    $(document).find('[data-section-type="product"] .shopify-payment-button').addClass('cmtNone');
  //  $('.selOption').show();
    $('.noSelect').show();
    $('.atc').hide();
  }
  $(document).on('click','.noSelect',function(){
  $('.selOption').show();
  });

});

$(document).ready(function(){
  $('li.HorizontalList__Item.sold:after').click(function(){
    alert("hello");
    $(this).find('input.SizeSwatch__Radio').attr('checked');
  
    //var check= $(this).attr('checked');
  });
});


// Bundles functionality
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class BundleItem extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('[data-bundle-item-input]'),
      switchProductButtons: this.querySelectorAll('[data-bundle-switch-product]'),
      optionButtons: this.querySelectorAll('[data-bundle-item-variant-option]')
    }

    this.index = parseInt(this.dataset.itemIndex);
    this.products = JSON.parse(this.querySelector('[data-bundle-item-products]').innerHTML);
    this.valid = false;
    this.selectedProduct = null;
    this.selectedVariant = null;
    this.selectedOptions = {
      option1: null,
      option2: null,
      option3: null
    };

    this.availableOptions = {};

    this.elements.switchProductButtons.forEach(
      (button) => button.addEventListener('click', this.switchProduct.bind(this))
    );
    
    this.elements.optionButtons.forEach(
      (button) => button.addEventListener('click', this.updateOptions.bind(this))
    );
  }

  switchProduct(event) {
    this.elements.switchProductButtons.forEach((button) => {
      button.setAttribute('aria-active', false);
    });
    event.currentTarget.setAttribute('aria-active', true);
    this.selectedProduct = this.products[event.currentTarget.dataset.bundleSwitchProduct];
    this.updateSelectedProduct();
  }

  updateSelectedProduct() {
    this.setProductAvailableOptions();
    if (this.selectedOptions.option1 != null || this.selectedOptions.option2 != null || this.selectedOptions.option3 != null) {
      this.selectedVariant = this.getOptionBasedVariant();
      if (!this.selectedVariant || !this.selectedVariant.available) {
        this.selectedVariant = this.selectedProduct.variants.find( variant => { return variant.available });
        this.updateSelectedOptionsBasedOnSelectedVariant();
      }
    } else {
      this.selectedVariant = this.selectedProduct.variants.find( variant => { return variant.available });

      this.updateSelectedOptionsBasedOnSelectedVariant();
    }

    this.updateVariant();
    if (this.selectedProduct.options.length > 1) {
      this.updateAvailableOptionsBasedOnVariantId();
    }
  }

  updateOptions(event) {
    event.currentTarget.parentNode.childNodes.forEach(button => {
      button.setAttribute('aria-active', false);
    })
    event.currentTarget.setAttribute('aria-active', true);
    this.selectedOptions[event.currentTarget.dataset.optionPosition] = event.currentTarget.dataset.optionValue;
    if (this.selectedProduct) {
      this.selectedVariant = this.getOptionBasedVariant();
      this.updateVariant();
    }
  }

  updateSelectedOptionsBasedOnSelectedVariant() {
    this.selectedOptions = {
      option1: this.selectedVariant.option1,
      option2: this.selectedVariant.option2,
      option3: this.selectedVariant.option3
    }

    this.elements.optionButtons.forEach(button => {
      button.setAttribute('aria-active', this.selectedOptions[button.dataset.optionPosition].includes(button.dataset.optionValue));
    });
  }

  getOptionBasedVariant() {
    let variant = this.selectedProduct.variants.find(variant => {
      return variant.option1 == this.selectedOptions.option1 && variant.option2 == this.selectedOptions.option2 && variant.option3 == this.selectedOptions.option3
    });
    return variant;
  }

  setProductAvailableOptions() {
    let availableOptions = {
      option1: [],
      option2: [],
      option3: []
    };

    let availableVariants = this.selectedProduct.variants.filter(variant => { return variant.available});

    for (i = 1; i <= this.selectedProduct.options.length; i ++) {
      [...availableVariants].forEach(variant => {
        availableOptions[`option${i}`].push(variant[`option${i}`]);
      });

      // Leaving only unique values
      availableOptions[`option${i}`] = [...new Set(availableOptions[`option${i}`])];
    }

    this.availableOptions = availableOptions;
    this.updateAvailableOptions(this.availableOptions);
  }

  updateAvailableOptions(availableOptions) {
    this.elements.optionButtons.forEach(button => {
      button.disabled = !availableOptions[button.dataset.optionPosition].includes(button.dataset.optionValue);
    });
  }

  updateAvailableOptionsBasedOnVariantId() {
    let availableOptions = {
      option1: [],
      option2: [],
      option3: []
    };

    let getVariantsWithSameOptions = getVariantsWithSameOptions(a);

    for (i = 1; i <= this.selectedProduct.options.length; i ++) {
      [...getVariantsWithSameOptions].forEach(variant => {
        availableOptions[`option${i}`].push(variant[`option${i}`]);
      });

      // Leaving only unique values
      availableOptions[`option${i}`] = [...new Set(availableOptions[`option${i}`])];
    }

    this.updateAvailableOptions(availableOptions);
  }

  updateVariant(){
    this.elements.input.value = this.selectedVariant.id;
    this.valid = true;
    this.dispatchEvent(new CustomEvent('updatedBundleItemVariant', { detail: {
      variant: this.selectedVariant,
      product: this.selectedProduct,
      index: this.index
    }}));
  }

  getVariantsWithSameOptions() {
    let availableVariants = this.selectedProduct.variants.filter(variant => {
      return variant.available == true;
    });

    let getVariantsWithSameOptions = availableVariants.filter(variant => {
      var willReturn = false;
      if (variant.option1 && ! willReturn) {
        willReturn = variant.option1 == option1;
      }
      if (variant.option2 && ! willReturn) {
        willReturn = variant.option2 == option2;
      }
      if (variant.option3 && ! willReturn) {
        willReturn = variant.option3 == option3;
      }
      return willReturn;
    });

    return getVariantsWithSameOptions;
  }
}


customElements.define('bundle-item', BundleItem);

class Bundle extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      imagesContainer: this.closest('.shopify-section').querySelector('.Product__FakeSlideshow'),
      addToCart: this.closest('form').querySelector('[type="submit"]'),
      propertyInputs: {
        bundleId: this.querySelector('[data-bundle-id]')
      },
      bundleItems: this.querySelectorAll('bundle-item')
    }

    this.selectedImages = [];
    this.elements.bundleItems.forEach(
      (bundleItem) => bundleItem.addEventListener('updatedBundleItemVariant', debounce(this.handleVariantUpdate.bind(this), 50))
    );

    this.allItemsSelected = false;
    this.checkValidity();
  }

  handleVariantUpdate(event) {
    this.selectedImages[event.detail.index] = event.detail.variant.featured_media?.preview_image || event.detail.product.media[0].preview_image;
    this.updateImages()

    this.elements.propertyInputs.bundleId.value = btoa(Date.now());
    this.checkValidity();
  }

  checkValidity() {
    var valid = true;
    this.elements.bundleItems.forEach((bundleItem) => {
      if(!bundleItem.valid) {
        valid = false;
      }
    });
    this.allItemsSelected = valid;
    this.updateButton();
  }

  updateButton() {
    if(this.allItemsSelected) {
      this.elements.addToCart.removeAttribute('disabled');
    } else {
      this.elements.addToCart.setAttribute('disabled', 'disabled');
    }
  }

  updateImages() {
    if (this.elements.imagesContainer.classList.contains('flickity-enabled')) {
      this.elements.imagesContainer.querySelector('.flickity-slider').innerHTML = "";
      this.selectedImages.forEach(image => {
        this.elements.imagesContainer.querySelector('.flickity-slider').innerHTML += `
          <div class="BundleItemImage">
            <div class="AspectRatio AspectRatio--withFallback" style="padding-bottom: ${image.width / image.height * 100}%; --aspect-ratio: ${image.aspect_ratio};">
              <img class="Image" src="${image.src}">
            </div>
          </div>
        `;
      });
      Flickity(this.elements.imagesContainer).reloadCells();
      Flickity(this.elements.imagesContainer).resize();
    } else {
      this.elements.imagesContainer.innerHTML = "";
      this.selectedImages.forEach(image => {
        this.elements.imagesContainer.innerHTML += `
          <div class="BundleItemImage">
            <div class="AspectRatio AspectRatio--withFallback" style="padding-bottom: ${image.width / image.height * 100}%; --aspect-ratio: ${image.aspect_ratio};">
              <img class="Image" src="${image.src}">
            </div>
          </div>
        `;
      });
    }
  }
}

customElements.define('bundle-product', Bundle);

document.addEventListener('rebuy:cart.change', function(event){ 
  var cart = event.detail.cart.cart;
  var bundledItems = cart.items.filter(item => {
    return item.properties && item.properties['__bundle_id']
  })
  var bundles = {};
  bundledItems.forEach(item => {
    if(bundles[item.properties['__bundle_id']]) {
      bundles[item.properties['__bundle_id']].currentQuantity += item.quantity;
      bundles[item.properties['__bundle_id']].items.push(item);
    } else {
      bundles[item.properties['__bundle_id']] = {
        requiredQuantity: parseInt(item.properties['__bundle_items_quantity']),
        currentQuantity: item.quantity,
        items: [
          item
        ]
      }
    }
  });

  var dataForUpdate = {
    updates: {}
  };

  Object.keys(bundles).forEach(key => {
    var bundle = bundles[key];
    if(bundle.requiredQuantity != bundle.currentQuantity) {
      if(bundle.items.length > 1) {
        bundle.items.forEach(item => {
          dataForUpdate.updates[item.key] = 0;
        });
      } else {
        dataForUpdate.updates[bundle.items[0].key] = bundle.requiredQuantity;
      }
    }
  })

  if(Object.keys(dataForUpdate.updates).length) {
    fetch(window.theme.localeRootUrl + '/cart/update.js', {
      body: JSON.stringify(dataForUpdate),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (response) {
      if (response.ok) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } else {
        response.json().then(function (content) {
          console.log(content['description']);
        })
      }
    }); 
  }
});

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.elements = {
      days: this.querySelector('.day .num'),
      hours: this.querySelector('.hour .num'),
      minutes: this.querySelector('.min .num'),
      seconds: this.querySelector('.sec .num'),
    }

    let splittedTargetDate = this.dataset.date.split('-');
    let splittedTargetTime = this.dataset.time.split(':');

    this.targetDate = {
      day: parseInt(splittedTargetDate[0]),
      month: parseInt(splittedTargetDate[1]) - 1,
      year: parseInt(splittedTargetDate[2]),
      hour: parseInt(splittedTargetTime[0]),
      minute: parseInt(splittedTargetTime[1]),
      timezoneOffset: parseInt(this.dataset.timezoneOffset),
    }

    let userTime = new Date();
    let userTimezoneOffset = userTime.getTimezoneOffset() * 60000;

    this.countDownDate = new Date(this.targetDate.year, this.targetDate.month, this.targetDate.day, this.targetDate.hour, this.targetDate.minute, 0, 0).getTime() - this.targetDate.timezoneOffset - userTimezoneOffset;
    
    this.interval = setInterval(_this.updateTime, 1000, _this);
    this.updateTime(_this);
  }

  updateTime(_this) {
    // Get todays date and time
    const now = new Date().getTime();
    
    // Find the distance between now an the count down date
    const distance = _this.countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    _this.elements.days.innerHTML = _this.addZero(days);
    _this.elements.hours.innerHTML = _this.addZero(hours);
    _this.elements.minutes.innerHTML = _this.addZero(minutes);
    _this.elements.seconds.innerHTML = _this.addZero(seconds);

    // If the count down is over, write some text
    if (distance < 0) {
      _this.innerHTML = "EXPIRED";
      clearInterval(_this.interval);
    }

  }

  addZero(x) {
    return (x < 10 && x >= 0) ? "0" + x : x;
  }
}

customElements.define('countdown-timer', CountdownTimer);